import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const Footer = () => {
  const { t } = useTranslation('footer');
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first with the hash
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0C3B2E] text-white">
      <div className={theme.container + ' py-12'}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Navigation Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              {Object.entries(t('navigation', { returnObjects: true })).map(([key, value]) => (
                <li key={key}>
                  <button 
                    onClick={() => scrollToSection(key === 'home' ? 'home' : key)}
                    className="hover:text-[#FFBA00] transition-colors"
                  >
                    {value}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p>
              {t('contact.questions')}{' '}
              <a href={`mailto:${t('contact.email')}`} className="text-[#FFBA00] hover:underline">
                {t('contact.email')}
              </a>
            </p>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="hover:text-[#FFBA00] transition-colors">
                  {t('legal.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/10 text-center">
          <p>© {currentYear} Memory Motion. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;